import { EMPTY } from 'rxjs';
import { Observable } from 'rxjs';
import { EventService } from '@biletix/core/services/event.service';
import { TicketSaleService } from "@biletix/core/services/ticket-sale.service";
import { Component, Input, OnInit, ViewChild, Inject } from '@angular/core'; 
import { InterestedEvent } from '@biletix/core/models/event/interested-events.model';
import { AbstractionComponent } from '@biletix/core/common/abstraction-component';
import { ShoppingCart } from '@biletix/core/models/shopping-cart/shopping-cart.model';
import { ProfileCampaign } from '@biletix/core/models/event/profile-campaign.model';
import { SwiperComponent } from "swiper/angular";
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Virtual, Zoom, Autoplay, Thumbs, Controller } from 'swiper';
import { ViewportScroller } from "@angular/common";
import { RouterService } from '@biletix/core/services/router.service';
import { ShoppingItem } from '@biletix/core/models/shopping-cart/shopping-item.model';
import { Router } from '@angular/router';
import { ImageUrlManager } from '@biletix/core/common/helper/image-url-manager';
import { APP_BASE_HREF } from "@angular/common";
import { RecommendedCampaigns, CampaignMember } from "@biletix/core/models/event/recommended-campaigns.model";
import { ApiResponse } from '@biletix/core/models/api-response'; 

SwiperCore.use([
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Virtual,
  Zoom,
  Autoplay,
  Thumbs,
  Controller
]);

@Component({
  selector: 'btx-recommended-campaigns',
  templateUrl: './recommended-campaigns.component.html',
  styleUrls: ['./recommended-campaigns.component.scss'],
  standalone: false
})
export class RecommendedCampaignsComponent extends AbstractionComponent implements OnInit {
  breakpoints = {
    1: { slidesPerView: 1, spaceBetween: 20 },
    640: { slidesPerView: 3, spaceBetween: 20 },
    959: { slidesPerView: 5, spaceBetween: 20 },
  };

  firstItem: ShoppingItem | any;
  interestedEvents: InterestedEvent[] = [];
  recommendedCampaignsData?: RecommendedCampaigns;
  campaignMembers: CampaignMember[] = [];
  profileCampaign: ProfileCampaign | undefined;
  profileCampaignImage: string = '';
  slideStart: boolean = false;

  @Input() shoppingCart?: ShoppingCart;
  @Input() region?: string;
  @Input() lang?: string;
  @Input() campaignName?: string;

  interestedEvents$: Observable<InterestedEvent[]> = EMPTY;

  constructor(
    private eventService: EventService,
    @Inject(APP_BASE_HREF) private baseHref: string,
    private viewportScroller: ViewportScroller,
    private ticketSaleService: TicketSaleService,
    private routerService: RouterService,
    private router: Router
  ) {
    super();
  }

  @ViewChild(SwiperComponent)
  swiper!: SwiperComponent;

  swipePrev() {
    this.swiper.swiperRef.slidePrev();
  }

  swipeNext() {
    this.swiper.swiperRef.slideNext();
  }

  ngOnInit(): void {
    if (this.campaignName) {
      this.eventService.getEventGroups(this.campaignName)
        .pipe(this.takeUntilDestroy())
        .subscribe((response: ApiResponse<RecommendedCampaigns>) => {
          if (response.data) {
            this.recommendedCampaignsData = response.data;
            this.campaignMembers = response.data.groupMembers || [];
            this.slideStart = this.campaignMembers.length > 2;
          }
        });
    }
  }

  get allRecommendCampaigns(): string {
    //return this.routerService.getPerformancePageUrl(this.firstItem?.eventCode, this.firstItem?.performanceCode);
    return `https://guides.biletix.com/${this.campaignName}/${this.region}/${this.lang}`;
  }
  getGuideUrl(alias: string) {
    return `https://guides.biletix.com/${alias}/${this.region}/${this.lang}`;
  }

  generateHref(eventCode?: string, region?: string, lang?: string): string {
    if (!eventCode || !region || !lang) {
      return '';
    }
    return `${this.baseHref}etkinlik/${eventCode}/${region}/${lang}`;
  }

  public handleMissingImage(event: Event) {
    (event.target as HTMLImageElement).setAttribute("src", "");
  }

  seeDetail() {
    this.viewportScroller.scrollToAnchor("seeDetail");
  }

  getExternalImage(imgUrl: string) {
    return ImageUrlManager.createGroupImage(imgUrl);
  }
}
